// extracted by mini-css-extract-plugin
export default {"searchButton":"EventSearch_searchButton__pH3Et"};